import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../services/services"
import _ from "underscore"
import { Urls } from "../../services/Urls"
import { ToastContext } from "../../context/ToastContext"
import { DateTime } from "luxon"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Calendar } from "primereact/calendar"
import { timeStringToDate } from "../../utils/Helper"

export const useCarouselImages = () => {

    const { showError, showSuccess, showInfo } = useContext(ToastContext);
    const [formValue, setFormValue] = useState({
        files: [],
    })
    const [files, setFiles] = useState({
        files: [],
    });
    const [isChange, setIsChange] = useState(false);
    const [loader, setLoader] = useState(false)


    useEffect(() => {
        getImage()
    }, []);

    const upsertImages = async (e, key, item) => {
        try {
            let payload;
            setLoader(true)
            e.preventDefault();
            if (key === "all") {
                if ((key !== "to_date") && (formValue?.files?.length === 0 || _.uniq(_.pluck((formValue?.files || []).filter(file => file.base64 !== undefined), "base64"))?.length === 0)) {
                    showInfo("Info", "Please select an image.")
                    return
                }
                payload = {
                    carousel_mapping_id: item?.carousel_mapping_id || 0,
                    carousel_image_order: formValue?.order || 0,
                    is_active: true,
                    from_date: formValue?.from_date ? DateTime.fromJSDate(new Date(formValue?.from_date)) : "",
                    to_date: formValue?.to_date ? DateTime.fromJSDate(new Date(formValue?.to_date)) : "",
                    Files: (formValue?.files || [])
                        ?.filter(file => file.base64 !== undefined)
                        ?.map(item => ({ base64String: item.base64, extension: item?.file?.type?.split("/")[1] || "" }))
                };
                setFormValue({ files: [] })
            } else {
                payload = {
                    carousel_mapping_id: item?.carousel_mapping_id || 0,
                    carousel_image_order: key === "order" ? e.target?.value : parseInt(item?.carousel_image_order || 0) || 0,
                    is_active: key === "is_active" ? e.target.checked : item?.is_active || true,
                    from_date: key === "from_date" ? (e.target.value ? DateTime.fromJSDate(new Date(e.target.value)) : "") : item?.from_date || "",
                    to_date: key === "to_date" ? (e.target.value ? DateTime.fromJSDate(new Date(e.target.value)) : "") : item?.to_date || "",
                    Files: [{ base64String: "", extension: "" }]
                };
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTCAROUSELMAPPING"), payload)
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                setLoader(false)
                getImage()
            } else {
                setLoader(false)
                showError("error", res.body.message)
            }
        } catch (error) {
            setLoader(false)
            console.error("error::", error)
        }
    }

    const getImage = async () => {
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETCAROUSELMAPPING"))
            if (!res?.body?.error_status) {
                const sort = _.sortBy(res?.body?.data?.carousel_details, "carousel_image_order")
                const images = _.filter(sort, item => item.is_active);
                const nullDates = images.filter(item => !item.from_date || !item.to_date);
                const filteredData = images.filter(item => {
                    if (!item.from_date && !item.to_date) {
                        return false;
                    }
                    return timeStringToDate("00:00", new Date()) >= new Date(item.from_date) && timeStringToDate("00:00", new Date()) <= new Date(item.to_date);
                });
                setFiles({
                    files: [{
                        id: "all",
                        title: "",
                        children: sort
                    }], activeImages: filteredData?.length > 0 ? filteredData : nullDates
                })
            }
        } catch (error) {
            console.error("error::", error)
        }
    }
    const handleDelete = async (item, index) => {
        try {
            if (!item?.carousel_mapping_id) {
                const newFiles = files.files.filter((_, i) => i !== index);
                setFiles((prev) => ({ ...prev, files: newFiles }));
                return
            }
            const payload = {
                "carousel_mapping_id": item?.carousel_mapping_id
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETECAROUSELMAPPING"), payload)
            if (!res?.body?.error_status) {
                showSuccess("Success", res?.body?.message);
                getImage();
            } else {
                showError("error", res.body.errorMessage)
            }
        } catch (error) {
            console.error("error::", error)
        }
    };


    const handleOnchange = (e) => {
        const { name, value } = e.target
        setFormValue((prev) => ({ ...prev, [name]: value }))
    }

    const columns = [
        {
            key: "image",
            label: "Image",
            headerStyle: { textAlign: "center" },
            style: { width: "15%", },
            render: (row) => {
                const isVideo = (typeof row.carousel_image_Path === 'string' && row.carousel_image_Path?.endsWith('mp4')) ||
                    (typeof row.file === 'object' && row.file?.type?.startsWith('video'));

                const src = typeof row.carousel_image_Path === 'string' || row.carousel_image_Path ?
                    row.carousel_image_Path :
                    URL.createObjectURL(row.file);

                return (
                    <div className="text-center">
                        {isVideo ? (
                            <video
                                src={src}
                                style={{ width: 60, height: 40 }}
                                controls
                            />
                        ) : (
                            <img
                                src={src}
                                alt={`Carousel image`}
                                style={{ width: 60, height: 40 }}
                            />
                        )}
                    </div>
                );
            },
        },
        {
            key: "from_date",
            label: "Start Date",
            headerStyle: { textAlign: "center" },
            style: { width: "25%" },
            render: (row) => (
                <div className="inspectra-calendar pe-1" >
                    <Calendar
                        value={row?.from_date ? new Date(row.from_date) : null}
                        onChange={(e) => upsertImages(e, "from_date", row)}
                        className="input-dd w15"
                        dateFormat="dd-mm-yy"
                        minDate={new Date()}
                    />
                </div>
            ),
        },
        {
            key: "to_date",
            label: "End Date",
            headerStyle: { textAlign: "center" },
            style: { width: "25%" },
            render: (row) => (
                <div className="inspectra-calendar pe-1">
                    <Calendar
                        value={row?.to_date ? new Date(row.to_date) : null}
                        onChange={(e) => upsertImages(e, "to_date", row)}
                        className="input-dd w15"
                        dateFormat="dd-mm-yy"
                        minDate={row?.from_date ? new Date(row.from_date) : new Date()}
                    />
                </div>
            ),
        },
        {
            key: "carousel_image_order",
            label: "Order",
            headerStyle: { paddingLeft: "10px", textAlign: "center" },
            style: { width: "15%" },
            render: (row) => (
                <div className="text-center pe-1">
                    <input
                        type="number"
                        className="input-dd w100"
                        value={row.carousel_image_order || 0}
                        onChange={(e) => {
                            setIsChange(true);
                            const newOrderValue = parseInt(e.target.value) || 0;
                            setFiles(prev => ({
                                ...prev,
                                files: prev.files?.map(file => ({
                                    ...file,
                                    children: file.children?.map(child =>
                                        child.carousel_mapping_id === row.carousel_mapping_id
                                            ? { ...child, carousel_image_order: newOrderValue }
                                            : child
                                    ) || file.children || []
                                })) || prev.files || [{ children: [] }]
                            }));

                        }}
                        min={0}
                        onBlur={(e) => { if (isChange) upsertImages(e, "order", row); }}
                    />
                </div>
            ),
        },
        {
            key: "is_active",
            label: "Active",
            headerStyle: { textAlign: "center", },
            style: { width: "10%" },
            render: (row) => (
                <div className="text-center">
                    <input
                        type="checkbox"
                        className="input-dd"
                        checked={row?.is_active === undefined ? true : row?.is_active}
                        onChange={(e) => {
                            upsertImages(e, "is_active", row);
                        }}
                    />
                </div>
            ),
        },
        {
            key: "delete",
            label: "Delete",
            headerStyle: { textAlign: "center", },
            style: { width: "10%" },
            render: (row, index) => (
                <div className="text-center">
                    <FontAwesomeIcon
                        icon="fa-solid fa-trash"
                        className="text-danger c-pointer"
                        onClick={() => handleDelete(row, index)}
                    />
                </div>
            ),
        }
    ];



    return useMemo(() => ({
        formValue, setFormValue, files, upsertImages, handleOnchange, columns, loader
    }), [formValue, setFormValue, files, upsertImages, handleOnchange, columns, loader])

}